module.exports = __webpack_public_path__ + "static/media/reports.c04e42e0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/reports.svg
// module id = 465
// module chunks = 5